"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VersionedAnswers = void 0;
const lodash_1 = __importDefault(require("lodash"));
class VersionedAnswers {
    // @ts-ignore
    // eslint-disable-next-line @typescript-eslint/naming-convention
    __tag = 'VersionedAnswers';
    v1;
    v2;
    constructor(answers) {
        this.v1 = JSON.parse(JSON.stringify(answers.v1)); // Create it owns pointer for answers.
        this.v2 = JSON.parse(JSON.stringify(answers.v2)); // Create it owns pointer for answers.
    }
    isEqual(otherAnswers) {
        return lodash_1.default.isEqual(this.v1, otherAnswers?.v1) && lodash_1.default.isEqual(this.v2, otherAnswers?.v2);
    }
}
exports.VersionedAnswers = VersionedAnswers;
